import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '@/lib/api';

const ServicesContext = createContext({ services: [], loading: true });

export const ServicesProvider = ({ children }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/services')
      .then((res) => setServices(res.data.services || []))
      .catch(() => setServices([]))
      .finally(() => setLoading(false));
  }, []);
  return (
    <ServicesContext.Provider value={{ services, loading }}>
      {children}
    </ServicesContext.Provider>
  );
};

export const useServices = () => useContext(ServicesContext);
